module.exports = __webpack_public_path__ + "img/kh2_26.8610fe3a.png";